/**
 * `AuditRecord` của audit-service (`openapi/platform-api.yaml`, tag `audit`) →
 * `SuKienAudit` của màn Nhật ký thao tác.
 *
 * audit-service lưu `source` chữ thường và tự do (`gateway`, `service`,
 * `keycloak` — lấy từ `type` của message Kafka nếu nguồn không ghi). Giao diện
 * chỉ dịch các nguồn đã biết; nguồn lạ thành `null` để ô "Nguồn ghi" hiện trống
 * thay vì một khoá dịch không tồn tại.
 */
import type { NguonGhi, QuyetDinh, SuKienAudit } from '../types.ts';

export interface AuditRecordApi {
  id: string;
  event_id?: string | null;
  tenant_id?: string | null;
  user_id?: string | null;
  action: string;
  resource?: string | null;
  decision: QuyetDinh;
  ip?: string | null;
  source?: string | null;
  detail?: Record<string, unknown> | null;
  created_at: string;
}

const NGUON_DA_BIET: readonly NguonGhi[] = ['GATEWAY', 'SERVICE', 'SDK', 'KEYCLOAK'];

export function nguonTuApi(source: string | null | undefined): NguonGhi | null {
  const ma = source?.trim().toUpperCase();
  return ma && (NGUON_DA_BIET as readonly string[]).includes(ma) ? (ma as NguonGhi) : null;
}

export function suKienTuApi(r: AuditRecordApi): SuKienAudit {
  return {
    id: r.id,
    event_id: r.event_id ?? null,
    tenant_id: r.tenant_id ?? null,
    user_id: r.user_id ?? null,
    action: r.action,
    resource: r.resource ?? null,
    decision: r.decision,
    ip: r.ip ?? null,
    source: nguonTuApi(r.source),
    detail: r.detail ?? null,
    created_at: r.created_at,
  };
}
